import { z } from "zod";

import {
  DEFAULT_PERIOD_OPTION,
  getTimespanFromPeriod,
} from "../../../../HookForm/TimespanSelect/const";

const optionsSchema = z.object({
  is_enabled: z.boolean(),
  ai_summary_enabled: z.boolean(),
});

export enum reviewsLanguagesOptions {
  ALL = "all",
  JAPANESE_ONLY = "japanese_only",
  CUSTOM = "custom",
}

const languagesSchema = z.object({
  option: z.nativeEnum(reviewsLanguagesOptions),
  custom_values: z.array(z.string()), // for when option is CUSTOM
});

export type LanguagesSchema = z.infer<typeof languagesSchema>;

// Reviews Schema extends optionsSchema,
// but using z.extend was not working as expected.
// If anyone can figure out how to make that work feel free.
const reviewsSchema = z.object({
  is_enabled: z.boolean(),
  ai_summary_enabled: z.boolean(),
  languages: languagesSchema,
});

export const schema = z.object({
  locations: z.array(z.object({ id: z.coerce.number(), name: z.string() })),
  timespan: z.object({
    start_date: z.date(),
    end_date: z.date(),
  }),
  options: z.object({
    search_keywords: optionsSchema,
    website: optionsSchema,
    calls: optionsSchema,
    route_search: optionsSchema,
    reviews: reviewsSchema,
    overall_ai_summary: z.object({
      is_enabled: z.boolean(),
    }),
  }),
});

export type Schema = z.infer<typeof schema>;

export const generateDefaultValues = (): Schema => {
  const period = DEFAULT_PERIOD_OPTION;
  const timespan = getTimespanFromPeriod(period);
  return {
    locations: [],
    timespan: {
      start_date: timespan.startDate ?? new Date(),
      end_date: timespan.endDate ?? new Date(),
    },
    options: {
      search_keywords: { is_enabled: true, ai_summary_enabled: true },
      website: { is_enabled: true, ai_summary_enabled: true },
      calls: { is_enabled: true, ai_summary_enabled: true },
      route_search: { is_enabled: true, ai_summary_enabled: true },
      reviews: {
        is_enabled: true,
        ai_summary_enabled: true,
        languages: { option: reviewsLanguagesOptions.ALL, custom_values: [] },
      },
      overall_ai_summary: { is_enabled: true },
    },
  };
};
